import React from "react";
import { useLang } from "../i18n";

const TL_COLORS = { verde: "#3B604E", giallo: "#D4A017", rosso: "#B7410E" };

export function LongevityMeter({ data }) {
  const { t } = useLang();
  if (!data) return null;

  return (
    <div className="rounded-3xl p-8 bg-[#2B4A59] text-[#FDFBF7] relative overflow-hidden" data-testid="longevity-meter">
      <div className="grain opacity-40" />
      <div className="relative">
        <div className="mb-1">
          <p className="text-xs uppercase tracking-widest text-white/50 mb-2">{t("longevity_score")}</p>
          <div className="flex items-baseline gap-2">
            <p className="font-serif text-6xl leading-none" data-testid="longevity-value">{data.score}</p>
            <span className="text-white/40 text-sm">pt</span>
          </div>
        </div>

        {data.bio && (
          <div className="mt-6 pt-5 border-t border-white/10" data-testid="bio-age">
            <p className="text-xs uppercase tracking-widest text-white/50 mb-3">{t("bio_title")}</p>
            <div className="flex items-end gap-4">
              <div>
                <p className="font-serif text-4xl" style={{ color: data.bio.delta > 0 ? "#8FD9A8" : "#FDFBF7" }} data-testid="bio-value">{data.bio.biological_age}</p>
                <p className="text-[11px] text-white/60">{t("bio_title")}</p>
              </div>
              <span className="text-white/40 text-xl pb-2">vs</span>
              <div>
                <p className="font-serif text-4xl text-white/80">{data.bio.chronological_age}</p>
                <p className="text-[11px] text-white/60">{t("chrono_age")}</p>
              </div>
              {data.bio.delta > 0 && (
                <span className="ml-auto rounded-full px-3 py-1 text-sm font-semibold bg-[#8FD9A8]/20 text-[#8FD9A8]">
                  −{data.bio.delta} {t("bio_younger")}
                </span>
              )}
            </div>
            <p className="text-[11px] text-white/40 mt-3">{t("bio_note")}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export function TrafficLight({ value }) {
  const { t } = useLang();
  const key = { verde: "tl_verde", giallo: "tl_giallo", rosso: "tl_rosso" }[value] || "tl_giallo";
  return (
    <span className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-sm font-semibold" style={{ backgroundColor: (TL_COLORS[value] || "#D4A017") + "22", color: TL_COLORS[value] || "#D4A017" }} data-testid="traffic-light">
      <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: TL_COLORS[value] || "#D4A017" }} />
      {t(key)}
    </span>
  );
}
